import Uri from 'jsuri';
import { SECURE_BASE_URL } from '../../config';
import { AppDispatch, DispatchThunk } from '../../types/common';
import {
  ChannelGroupTypes,
  ChannelsGroup,
  LandingPageResponseType,
} from '../../types/landing-page';
import { CATCH_ERROR } from '../../utils/defaults';
import { fetchWithRetry } from '../../utils/promise';
import { checkResponse } from '../../web-shared/utils/billing';
import { LandingPageState } from '../defaults/landing-page';
import { RootState } from '../reducers';
import { getIsLoadingLandingPageData } from '../selectors/landing-page';

export const SET_UPDATE_LANDING_PAGE_INFO = 'APP_UPDATE_LANDING_PAGE_INFO';

export const LANDING_PAGE_DATA_URL = `${SECURE_BASE_URL}/landing/10_ft_landing_page?genres=true&logo_type=large`;

interface UpdateLandingPageInfoAction {
  type: typeof SET_UPDATE_LANDING_PAGE_INFO;
  payload: Partial<LandingPageState>;
}

export function updateLandingPageInfo(
  payload: Partial<LandingPageState>,
): UpdateLandingPageInfoAction {
  return {
    type: SET_UPDATE_LANDING_PAGE_INFO,
    payload,
  };
}

export function processLandingPageData(response: {
  result: LandingPageResponseType;
}): DispatchThunk {
  return dispatch => {
    const channelGroups = response.result?.channel_groups;
    const channelGenreGroups = response.result?.genres;

    const isBundlePlusEnabled = channelGroups.some(
      (channelGroup: ChannelsGroup) => channelGroup.type === ChannelGroupTypes.CALLOUT,
    );

    dispatch(
      updateLandingPageInfo({
        channelGroups,
        channelGenreGroups,
        isBundlePlusEnabled,
        isLoadingLandingPageData: false,
        landingPageDataLoaded: true,
      }),
    );
  };
}

export function loadLandingPageData() {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    if (getIsLoadingLandingPageData(state)) {
      return Promise.resolve();
    }
    dispatch(
      updateLandingPageInfo({
        isLoadingLandingPageData: true,
        landingPageDataLoaded: false,
      }),
    );

    const landingPageDataURL = new Uri(LANDING_PAGE_DATA_URL);

    return fetchWithRetry(landingPageDataURL.toString(), {
      method: 'GET',
      credentials: 'include',
    })
      .then(checkResponse)
      .then(json => {
        if (!json.success) {
          dispatch(
            updateLandingPageInfo({
              isLoadingLandingPageData: false,
            }),
          );
          CATCH_ERROR(json.error);
          return;
        }
        dispatch(processLandingPageData(json));
      })
      .catch(error => {
        dispatch(
          updateLandingPageInfo({
            isLoadingLandingPageData: false,
          }),
        );
        CATCH_ERROR(error);
      });
  };
}
